"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _button = _interopRequireDefault(require("./button"));

require("../css/filepicker.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var FilePicker =
/*#__PURE__*/
function (_React$Component) {
  _inherits(FilePicker, _React$Component);

  function FilePicker(props) {
    var _this;

    _classCallCheck(this, FilePicker);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FilePicker).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getPlaceholder", function () {
      var PLACEHOLDER = _react.default.createElement("span", {
        className: "vn-filepicker__placeholder"
      }, _this.props.placeholder);

      return _this.props.placeholder ? PLACEHOLDER : '';
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleClick", function (event) {
      if (_this.fileInput) {
        _this.fileInput.click();
      }

      if (_this.props.onClick) {
        _this.props.onClick(event);
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleChange", function (event) {
      var names = _this.getPlaceholder();

      var filenames = [];
      var files = event.target.files;

      for (var i = 0; i < files.length; i += 1) {
        filenames.push(files[i].name.toLowerCase());
      }

      if (filenames.length !== 0) {
        names = filenames.join(', ');
      }

      var selectedFiles = event.target.files;

      if (_this.props.accept !== '*.*') {
        var accepts = _this.props.accept.toLowerCase().split(',');

        var validfiles = filenames.map(function (filename) {
          var fileSplited = filename.split('.');
          return accepts.indexOf(".".concat(fileSplited[fileSplited.length - 1]));
        });
        if (validfiles.indexOf(-1) !== -1) names = '';
        if (names === '') selectedFiles = [];
      }

      _this.setState({
        value: names
      });

      if (_this.props.onChange) {
        _this.props.onChange(event, selectedFiles);
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleFocusIn", function (event) {
      _this.setState({
        focused: true
      });

      if (_this.props.onFocusIn) {
        _this.props.onFocusIn(event);
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleFocusOut", function (event) {
      _this.setState({
        focused: false
      });

      if (_this.props.onFocusOut) {
        _this.props.onFocusOut(event);
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleMouseOver", function (event) {
      _this.setState({
        hover: true
      });

      if (_this.props.onMouseOver) {
        _this.props.onMouseOver(event);
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleMouseOut", function (event) {
      _this.setState({
        hover: false
      });

      if (_this.props.onMouseOut) {
        _this.props.onMouseOut(event);
      }
    });

    _this.state = {
      focused: false,
      hover: false,
      value: null
    };
    return _this;
  }

  _createClass(FilePicker, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var error = this.props.error;
      var classes = {
        'vn-filepicker': true,
        'vn-filepicker--expanded': true
      };

      if (this.props.className) {
        classes[this.props.className] = true;
      }

      var divClasses = (0, _classnames.default)({
        'vn-filepicker__file-name': true,
        'vn-filepicker__file-name--focused': this.state.focused,
        'vn-filepicker__file-name--no-focused': !this.state.focused,
        'vn-filepicker__file-name--hover': this.state.hover,
        'vn-filepicker__file-name--no-hover': !this.state.hover,
        'vn-filepicker__file-name--disabled': this.props.disabled,
        'vn-filepicker__file-name--error': error
      });
      var placeholder = this.getPlaceholder();
      var text = this.state.value ? this.state.value : placeholder;
      return _react.default.createElement("div", {
        className: (0, _classnames.default)(classes)
      }, _react.default.createElement("a", {
        className: "vn-filepicker__link",
        onClick: this.handleClick,
        onFocus: this.handleFocusIn,
        onBlur: this.handleFocusOut,
        onMouseOver: this.handleMouseOver,
        onMouseOut: this.handleMouseOut,
        role: "none"
      }, _react.default.createElement("div", {
        className: divClasses,
        title: this.state.value
      }, text), _react.default.createElement(_button.default, {
        type: "button",
        disabled: this.props.disabled
      }, this.props.i18n.browse), _react.default.createElement("input", {
        accept: this.props.accept,
        className: "vn-filepicker__input-file",
        disabled: this.props.disabled,
        multiple: this.props.multiple,
        name: this.props.name,
        onChange: this.handleChange,
        type: "file",
        ref: function ref(input) {
          _this2.fileInput = input;
        }
      })));
    }
  }]);

  return FilePicker;
}(_react.default.Component);

FilePicker.propTypes = {
  accept: _propTypes.default.string,
  className: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  error: _propTypes.default.bool,
  i18n: _propTypes.default.shape({
    browse: _propTypes.default.string.isRequired
  }),
  multiple: _propTypes.default.bool,
  name: _propTypes.default.string.isRequired,
  onChange: _propTypes.default.func,
  onClick: _propTypes.default.func,
  onFocusIn: _propTypes.default.func,
  onFocusOut: _propTypes.default.func,
  onMouseOver: _propTypes.default.func,
  onMouseOut: _propTypes.default.func,
  placeholder: _propTypes.default.string
};
FilePicker.defaultProps = {
  accept: '*.*',
  className: '',
  disabled: false,
  error: false,
  i18n: {
    browse: 'BROWSE'
  },
  multiple: false,
  onChange: null,
  onClick: null,
  onFocusIn: null,
  onFocusOut: null,
  onMouseOver: null,
  onMouseOut: null,
  placeholder: ''
};
FilePicker.displayName = 'FilePicker';
var _default = FilePicker;
exports.default = _default;